import pluralize from 'pluralize';
import { first, take } from 'lodash';
import React from 'react';
import Section from '~/App/Modules/TodoList/Components/GreetDetails/Section';

import ProfileImage from '~/App/Components/ProfileImage';
import ProfileHeader from '~/App/Modules/TodoList/Components/GreetDetails/ProfileHeader';
import HeaderActions from '~/App/Modules/TodoList/Components/Greet/HeaderActions';
import { Greet, Profile } from '~/types/models';
import { useSpring, animated } from 'react-spring';

interface AssigneeProps {
  image: string;
  firstName: string | null;
  email: string;
}

const Assignee = ({ image, firstName, email }: AssigneeProps) => {
  return (
    <p className='body-copy flex-1 justify-end text-right float-right'>
      <img src={image} height={40} width={40} className='mr-3 rounded-full' />
      Assigned to {firstName || email}
    </p>
  );
};

export interface HeaderProps {
  greet: Greet;
}

const Header = ({ greet }: HeaderProps) => {
  const { profiles } = greet;
  const profile = first(profiles);

  const animationProps = useSpring({
    opacity: 1,
    from: { opacity: 0 },
  });

  if (profiles.length > 1) {
    return (
      <animated.div style={animationProps}>
        <Section className='mb-none'>
          <div className='float-left inline-flex'>
            <span className='heading'>
              {pluralize('contact', profiles.length, true)} selected
            </span>
          </div>
          <div className='float-left mt-2 lg:float-right lg:mt-0'>
            <HeaderActions greet={greet} showAssign={true} showWorkspace />
          </div>
        </Section>
        <Section className='mt-5'>
          <div className='float-left inline-flex'>
            {take(profiles, 5).map((profile) => (
              <ProfileImage
                key={profile.id}
                profile={profile}
                size={40}
                className='mr-1.5'
              />
            ))}
            {profiles.length > 5 && (
              <div className='sub-heading'>
                and {profiles.length - 5} more{' '}
                {pluralize('contact', profiles.length - 5)}
              </div>
            )}
          </div>
          <Assignee
            image={greet.assignee.image}
            firstName={greet.assignee.first_name}
            email={greet.assignee.email}
          />
        </Section>
      </animated.div>
    );
  }

  return (
    <animated.div style={animationProps}>
      <Section className='mb-none mt-4 md:mt-0'>
        <div className='float-left inline-flex'>
          <ProfileImage profile={profile as Profile} size={50} />
          <ProfileHeader
            className='flex items-center justify-center'
            greet={greet}
          />
        </div>
        <div className='float-left mt-2 lg:float-right lg:mt-0'>
          <HeaderActions greet={greet} showAssign={true} showWorkspace />
        </div>
      </Section>
    </animated.div>
  );
};

export default Header;
